import Vue from 'vue';
import Router from 'vue-router';

import store from '../store/store';

import Home from '../views/Home';
import AdvancedSearch from '../views/AdvancedSearch';
import AdvancedSearchResult from '../views/AdvancedSearchResult';
import Login from '../views/Login';
import PostDetail from '../views/PostDetail';
import Stores from '../views/Stores';
import User from '../views/User';
import Account from '../views/Account';
import MyProfileEdit from '../views/MyProfileEdit';
import CreatePost from '../views/CreatePost';
import PostEdit from '../views/PostEdit';
import Forgot from '../views/Forgot';
import Reset from '../views/Reset';
import PrivacyPolicy from '../views/PrivacyPolicy';
import Advice from '../views/Advice';

import { FILTER_NAMES } from './../store/constant';

Vue.use(Router);

const fetchFilters = () => {
  for(let key in FILTER_NAMES) {
    store.dispatch('FETCH_FILTERS', key);
  }
  /*
  ['Type', 'SubType', 'Maker', 'BreakType', 'FrameSize', 'Gears', 'Gender', 'Material', 'MudGuardType', 'NumOfWheels', 'SuspensionType', 'TyreType', 'WheelSize', 'RackType', 'BasketType'].forEach(filter => {
    store.dispatch('FETCH_FILTERS', filter);
  });
  */
};

const checkAuth = (_, __, next) => {
  fetchFilters();
  if (!store.getters.isAuthenticated) {
    next('/login');
    return;
  }
  if(!store.state.authenticatedUser) store.dispatch('FETCH_AUTH_USER');
  next();
};

const fetchUserIfAuthorized = (_, __, next) => {
  fetchFilters();
  if(store.getters.isAuthenticated && !store.state.authenticatedUser) store.dispatch('FETCH_AUTH_USER');
  next();
};

const byPassIfAuthenticated = (_, __, next) => {
  fetchFilters();
  if (store.getters.isAuthenticated) {
    next('/');
    return;
  }
  next();
};


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/post/:postID',
      name: 'postDetail',
      component: PostDetail,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/post/:postID/edit',
      name: 'postEdit',
      component: PostEdit,
      beforeEnter: checkAuth
    },
    {
      path: '/advanced-search',
      name: 'advanced-search',
      component: AdvancedSearch,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/advanced-search/result',
      name: 'advanced-search-result',
      component: AdvancedSearchResult,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/stores',
      name: 'stores',
      component: Stores,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/user/:userID',
      name: 'user',
      component: User,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      beforeEnter: checkAuth
    },
    {
      path: '/profile',
      name: 'profile',
      component: MyProfileEdit,
      beforeEnter: checkAuth
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: byPassIfAuthenticated
    },
    {
      path: '/create',
      name: 'create',
      component: CreatePost,
      beforeEnter: fetchUserIfAuthorized
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
      beforeEnter: byPassIfAuthenticated
    },
    {
      path: '/reset',
      name: 'reset',
      component: Reset,
      beforeEnter: byPassIfAuthenticated
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy
    },
    {
      path: '/advice',
      name: 'advice',
      component: Advice
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      beforeEnter: fetchUserIfAuthorized
    }
  ]
})
